import { Button, Grid, TextField } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useForm } from 'react-hook-form';
import { TOKEN_KEY, url } from 'src/Helpers/utils/Constant';
import Toaster from 'src/Toaster/Toaster';
import MultipleAndSingleImgValidateWithPreview from 'src/common/FileValidation/MultipleAndSingleImgValidateWithPreview';

interface GProps {
  handleClose: Function;
  setRefreshTrigger: Function;
}

export default function CreateGallery({
  handleClose,
  setRefreshTrigger,
}: GProps) {
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: '',
      gallery_images: {},
    },
  });

  const [previewFiles, setPreviewFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState<Boolean>(false);
  const Toast = Toaster();
  const token = localStorage.getItem(TOKEN_KEY);

  // 🔥 Take files from custom component
  const handleFileChange = (filesObject: any) => {
    const newPreview: File[] = [];

    Object.keys(filesObject).forEach((key) => {
      const fileList = filesObject[key];
      if (fileList && fileList[0]) {
        newPreview.push(fileList[0]);
      }
    });

    setPreviewFiles(newPreview);
    setValue('gallery_images', filesObject);
  };

  // ================= SUBMIT ==================
  const onSubmit = async (formValues) => {
    setLoading(true);
    const formData = new FormData();
    console.log(formValues);
    try {
      formData.append('title', formValues.title);

      Object.keys(formValues?.gallery_images || {})?.forEach((key) => {
        const fileList = formValues.gallery_images[key];
        if (fileList) formData.append('attachments', fileList); // fileList already a File
      });

      const { data } = await axios.post(
        `${url}/api/v1/admin/gallery`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (data.success) {
        Toast.fire({ icon: 'success', title: data.message });
        setRefreshTrigger((prev: number) => prev + 1);
        handleClose();
      } else {
        Toast.fire({ icon: 'fail', title: data.message });
      }
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: error?.response?.data?.message || 'Upload failed',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Atab - Create Gallery</title>
      </Helmet>

      <Box component='form' onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          {/* Title */}
          <Grid item xs={12}>
            <TextField
              margin='normal'
              fullWidth
              required
              label='Enter a title'
              {...register('title')}
              variant='outlined'
            />
          </Grid>

          {/* Custom File Upload */}
          <Grid item xs={12}>
            <MultipleAndSingleImgValidateWithPreview
              mt='0'
              fileLimitSize={50}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Gallery Images'
              fieldName='gallery_images'
              hideCustomLabel
              mode='multiple'
              onlyImage
              imgSerUrl={[]}
              isRequired
            />
          </Grid>

          {/* PREVIEW IMAGES */}
          {previewFiles.length > 0 && (
            <Grid item xs={12}>
              <Box display='flex' flexWrap='wrap' gap={2} mt={2}>
                {previewFiles.map((file, index) => (
                  <img
                    key={index}
                    src={URL.createObjectURL(file)}
                    width={50}
                    height={50}
                    alt={`preview-${index}`}
                    style={{
                      borderRadius: 8,
                      objectFit: 'cover',
                      boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                    }}
                  />
                ))}
              </Box>
            </Grid>
          )}
        </Grid>

        {/* LOADING BUTTON */}
        {loading ? (
          <Button
            disabled
            fullWidth
            variant='contained'
            sx={{ mt: 3, mb: 2, py: 1 }}
          >
            loading...
          </Button>
        ) : (
          <Button
            type='submit'
            fullWidth
            variant='contained'
            sx={{ mt: 3, mb: 2, py: 1 }}
          >
            Create gallery
          </Button>
        )}
      </Box>
    </>
  );
}
